import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import { Login, Register } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Console from "@/pages/Console";
import Pricing from "@/pages/Pricing";
import Docs from "@/pages/Docs";
import Tools from "@/pages/Tools";
import Launch from "@/pages/Launch";
import Admin from "@/pages/Admin";
import Compare from "@/pages/Compare";
import { PaymentSuccess } from "@/pages/PaymentSuccess";
import { AuthProvider } from "@/context/AuthContext";

function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0f172a",
              color: "#f8fafc",
              border: "1px solid #1e293b",
            },
          }}
        />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/console" element={<Console />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/launch" element={<Launch />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
